import ArticleText from '../Post/PostText';
// import styles from './Services.module.css';
// import StrongText from '../Post/StrongText';
import Cards from '../Card/Cards';
import MyGallery from '../MyGallery/MyGallery';
const Services = () => {
  return (
    <div id="serviceSection">
      <Cards></Cards>
      <ArticleText>Ukázka aquaponické farmy na Plzeňsku</ArticleText>
      <div>
        <MyGallery></MyGallery>
      </div>
    </div>
  );
};

export default Services;
